import React from 'react'

import Autocomplete from 'components/Autocomplete'
import { useEventContext } from 'context/EventContext'
import highlightWords, { escapeRegexSpecialCharacters } from 'helpers/highlightWords'

import classes from './AutocompleteInput.module.scss'

const noop = () => {}
const INPUT_PLACEHOLDER = 'Select from list'

/** @type {import("./types").default} */
const AutocompleteInput = ({
  onChange = noop,
  onSelect = noop,
  onClear = noop,
  options = [],
  optionLabel = 'name',
  placeholder = INPUT_PLACEHOLDER,
}) => {
  const { sendEvent } = useEventContext()

  return (
    <Autocomplete
      className="AutocompleteInput"
      onChange={onChange}
      componentsClasses={{
        paper: classes.suggestionPaperContainer,
        listbox: classes.suggestionContainer,
        option: classes.suggestionOption,
      }}
      fullWidth
      options={options}
      onClear={onClear}
      onSelect={onSelect}
      getLabel={option => option.name}
      inputProps={{
        placeholder,
        onMouseDown: () => {
          sendEvent({
            engagementComponent: 'add-to-compare',
            engagementDestination: 'compare_search_select-search-bar',
            engagementDetails: 'search-bar',
            name: 'engagement_facet_click',
          })
        },
      }}
      renderOption={(option, { inputValue }) =>
        option.disabled ? (
          <div>
            <div className={classes.noResultsTitle}>Sorry, we couldn’t find any matches.</div>
            <div className={classes.noResultsText}>
              Make sure your keywords are spelled correctly or try another search.
            </div>
          </div>
        ) : (
          <span
            className={classes.suggestionText}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: highlightWords(option[optionLabel], escapeRegexSpecialCharacters(inputValue)),
            }}
          />
        )
      }
      getOptionDisabled={option => option.disabled}
    />
  )
}

export default AutocompleteInput
